import createIcon from '../../createIcon';

/**
 * @component @name ReadMore
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgN0gxM1Y5SDIyVjdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjIgMTVIMTNWMTdIMjJWMTVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjIgMTFIMTZWMTNIMjJWMTFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTMgMTJMOCA3VjExSDJWMTNIOFYxN0wxMyAxMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ReadMore = createIcon('ReadMore', [
  ['path', { d: 'M22 7H13V9H22V7Z', key: '145lew' }],
  ['path', { d: 'M22 15H13V17H22V15Z', key: 'vy1ypj' }],
  ['path', { d: 'M22 11H16V13H22V11Z', key: 'lsqwxi' }],
  ['path', { d: 'M13 12L8 7V11H2V13H8V17L13 12Z', key: '37ifqc' }],
]);

export default ReadMore;
